import OrderPrintsModal from './OrderPrintsModal';

export default OrderPrintsModal;



// WEBPACK FOOTER //
// ./src/components/Modals/OrderPrintsModal/index.ts